/* ============================================================
   Marquee Announcement Bar — behavior
   - Tap to pause/resume on touch devices (CSS :hover doesn't
     fire reliably on touch, so this fills the gap)
   - Pauses the animation while the section is off-screen to
     save CPU/battery (with the bar set to sticky, this rarely
     fires once scrolled past — it stays pinned in the viewport)
   - Publishes the bar's live rendered height as the CSS custom
     property --mrq-bar-height on <html>. This section can't
     reach into your theme's header.liquid on its own, so if a
     "Floating header" / transparent-header setting in your theme
     is pinning the header to the very top of the screen and it's
     overlapping this bar, add one line to that header's CSS:
       top: var(--mrq-bar-height, 0px);
     That offsets the header down by exactly the bar's height so
     both stay visible and stacked instead of overlapping.
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  var bars = document.querySelectorAll('[data-mrq-bar]');
  if (!bars.length) return;

  var isTouch = window.matchMedia('(hover: none)').matches;

  bars.forEach(function (bar) {
    var track = bar.querySelector('.mrq-track');
    if (!track) return;

    if (isTouch) {
      bar.addEventListener('click', function () {
        bar.classList.toggle('mrq-is-paused');
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('mrq-is-offscreen', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(bar);
    }

    function publishHeight() {
      var height = bar.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--mrq-bar-height', height + 'px');
    }

    publishHeight();
    window.addEventListener('resize', publishHeight);

    if ('ResizeObserver' in window) {
      new ResizeObserver(publishHeight).observe(bar);
    }
  });
});